import { Suspense, lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { AuthGuard } from '@/features/auth';
import { NotFoundPage } from './shell/NotFoundPage';

const LazyShiftbookPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookPage').then((module) => ({
    default: module.ShiftbookPage,
  })),
);
const LazyShiftbookAdminGroupsPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookAdminGroupsPage').then((module) => ({
    default: module.ShiftbookAdminGroupsPage,
  })),
);
const LazyShiftbookAdminUsersPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookAdminUsersPage').then((module) => ({
    default: module.ShiftbookAdminUsersPage,
  })),
);
const LazyShiftbookAdminDashboardPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookAdminDashboardPage').then((module) => ({
    default: module.ShiftbookAdminDashboardPage,
  })),
);
const LazyShiftbookAdminFlocsPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookAdminFlocsPage').then((module) => ({
    default: module.ShiftbookAdminFlocsPage,
  })),
);
const LazyShiftbookAdminTemplatesPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookAdminTemplatesPage').then((module) => ({
    default: module.ShiftbookAdminTemplatesPage,
  })),
);
const LazyShiftbookAdminKeywordsPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookAdminKeywordsPage').then((module) => ({
    default: module.ShiftbookAdminKeywordsPage,
  })),
);
const LazyShiftbookAdminSuggestionKapTagsPage = lazy(() =>
  import('../features/shiftbook/page/ShiftbookAdminSuggestionKapTagsPage').then((module) => ({
    default: module.ShiftbookAdminSuggestionKapTagsPage,
  })),
);
const LazyLoginPage = lazy(() =>
  import('../features/auth/pages/LoginPage').then((module) => ({
    default: module.LoginPage,
  })),
);

function ShiftbookRouteFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center text-sm text-[var(--color-text-tertiary)]">
      Loading...
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<ShiftbookRouteFallback />}>
        <LazyLoginPage />
      </Suspense>
    ),
  },
  {
    path: '/login/superadmin',
    element: (
      <Suspense fallback={<ShiftbookRouteFallback />}>
        <LazyLoginPage />
      </Suspense>
    ),
  },
  {
    path: '/admin',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookAdminDashboardPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/admin/groups',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookAdminGroupsPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/admin/users',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookAdminUsersPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/admin/flocs',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookAdminFlocsPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/admin/templates',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookAdminTemplatesPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/admin/keywords',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookAdminKeywordsPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: '/admin/suggestion-kap-tags',
    element: (
      <AuthGuard>
        <Suspense fallback={<ShiftbookRouteFallback />}>
          <LazyShiftbookAdminSuggestionKapTagsPage />
        </Suspense>
      </AuthGuard>
    ),
  },
  { path: '*', element: <NotFoundPage /> },
]);
